import * as React from 'react';
import Service from '../Service';
import { Case, CheckedBaggage } from '../../../../../Icons';
import { useServicePageProps } from '../../../../../CheckoutAdditionalService/components/hooks';
import ServiceCardDialog from '../../../../../Checkout/components/Checkout/OrderPaidServiceCards/components/ServiceCardDialog/ServiceCardDialog';
import ServicePage from '../../../../../Checkout/components/Checkout/ServicePage/ServicePage';
import { ServiceType } from '../../../../../Checkout/components/Checkout/OrderPaidServiceCards/types';
import { useTranslation } from 'react-i18next';
import { BaggageType, OrderAdditionalServiceGdsServiceServiceType } from '@websky/graphql';
const Baggage = ({ services }) => {
    const baggageServicesMap = new Map(), carryOnServicesMap = new Map();
    const { t } = useTranslation('FlightInfoCard');
    services.selectedServices.forEach(service => {
        const baggage = service.service, baggageSize = `${baggage.value.amount} ${t(baggage.value.measurement)}`;
        if (baggage.type === BaggageType.CarryOn) {
            carryOnServicesMap.set(baggageSize, (carryOnServicesMap.get(baggageSize) || 0) + service.count);
        }
        else {
            baggageServicesMap.set(baggageSize, (baggageServicesMap.get(baggageSize) || 0) + service.count);
        }
    });
    const baggageTexts = [], carryOnTexts = [];
    baggageServicesMap.forEach((count, size) => baggageTexts.push(`${size}, ${count} ${t('pc')}`));
    carryOnServicesMap.forEach((count, size) => carryOnTexts.push(`${size}, ${count} ${t('pc')}`));
    const servicePageProps = useServicePageProps();
    const open = () => servicePageProps.toggleModal(ServiceType.Baggage);
    return (React.createElement(React.Fragment, null,
        services.type === 'CarryOn' && carryOnTexts.length > 0 && (React.createElement(Service, { icon: Case, selected: true, onClick: open },
            React.createElement("span", null,
                t('Carry on'),
                ": ",
                carryOnTexts.join('; ')))),
        services.type === OrderAdditionalServiceGdsServiceServiceType.Baggage && (React.createElement(Service, { icon: CheckedBaggage, selected: baggageTexts.length > 0, onClick: open }, baggageTexts.length > 0 ? (React.createElement("span", null,
            t('Checked baggage'),
            ": ",
            baggageTexts.join('; '))) : (React.createElement("span", null, t('Buy a luggage with discount up to 20%'))))),
        React.createElement(ServicePage, null, childrenProps => (React.createElement(ServiceCardDialog, Object.assign({ order: servicePageProps.order, openedModal: servicePageProps.openedModal, onClose: servicePageProps.toggleModal.bind(null, null), passengers: servicePageProps.passengers, passengerLabels: servicePageProps.passengerLabels }, childrenProps))))));
};
export default Baggage;
